/* Editorial PDP: keep gallery order stable.
   On a variant change the standard gallery moves that variant's image and thumbnail to the
   front of the list. On this template the order stays fixed and the gallery just switches
   to the variant's image, so thumbnail positions never shuffle. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('media-gallery').then(function () {
    var MediaGallery = customElements.get('media-gallery');
    if (!MediaGallery || MediaGallery.prototype.__hmPatched) return;
    var original = MediaGallery.prototype.setActiveMedia;
    MediaGallery.prototype.setActiveMedia = function (mediaId, prepend) {
      if (this.closest('.hm-editorial')) prepend = false;
      return original.call(this, mediaId, prepend);
    };
    MediaGallery.prototype.__hmPatched = true;
  });
})();

/* Desktop: when the active thumbnail changes (variant switch, many images), scroll it into view
   inside the vertical thumbnail column without moving the page. */
(function () {
  if (!window.MutationObserver) return;
  var watch = function () {
    document.querySelectorAll('.hm-editorial .thumbnail-slider .thumbnail-list').forEach(function (list) {
      if (list.dataset.hmWatch) return;
      list.dataset.hmWatch = '1';
      new MutationObserver(function () {
        if (window.innerWidth < 990) return;
        var active = list.querySelector('.thumbnail[aria-current]');
        if (!active) return;
        var item = active.closest('.thumbnail-list__item');
        var top = item.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
        if (top < list.scrollTop || top + item.offsetHeight > list.scrollTop + list.clientHeight) {
          list.scrollTo({ top: top - 8, behavior: 'smooth' });
        }
      }).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* Compact quick-add modal (Complete your setup):
   1) Option buttons become dropdowns. The original radio inputs stay in place (hidden) and
      the dropdown just selects them, so Dawn's variant logic runs unchanged. Rebuilt whenever
      the modal content re-renders (open, variant change).
   2) Mobile: swipe the handle down, or tap outside the sheet, to close. */
(function () {
  function labelText(fs, input) {
    var label = fs.querySelector('label[for="' + input.id + '"]');
    if (!label) return input.value;
    var clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach(function (el) { el.remove(); });
    var text = clone.textContent.replace(/\s+/g, ' ').trim() || input.value;
    if (input.classList.contains('disabled')) text += ' (sold out)';
    return text;
  }

  function buildSelects(root) {
    root.querySelectorAll('variant-selects fieldset.product-form__input').forEach(function (fs) {
      if (fs.querySelector('.hm-qa-select')) return;
      var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return;
      var name = fs.querySelector('.option-name');
      var select = document.createElement('select');
      select.className = 'hm-qa-select';
      select.setAttribute('aria-label', name ? name.textContent.trim() : 'Option');
      radios.forEach(function (radio) {
        var option = document.createElement('option');
        option.value = radio.id;
        option.textContent = labelText(fs, radio);
        if (radio.checked) option.selected = true;
        select.appendChild(option);
      });
      select.addEventListener('change', function (event) {
        // Keep this change away from Dawn's variant handler; the radio change below drives it.
        event.stopPropagation();
        var radio = fs.querySelector('#' + CSS.escape(select.value));
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
      var wrap = document.createElement('div');
      wrap.className = 'hm-qa-select-wrap';
      wrap.appendChild(select);
      fs.appendChild(wrap);
      fs.classList.add('hm-qa-has-select');
    });
  }

  // The accessory cards (and their modals) load after the page, and Dawn moves each modal to
  // the end of <body>, so watch the whole document and rebuild whenever modal content lands.
  // Build synchronously in the observer callback (it runs before the browser paints), so the
  // freshly rendered option buttons never show for a frame before becoming dropdowns.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.nodeType === 1 && t.closest && t.closest('.hm-qa')) {
        document.querySelectorAll('quick-add-modal .hm-qa').forEach(buildSelects);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Tap outside the sheet closes it
  document.addEventListener('click', function (e) {
    var modal = e.target;
    if (modal && modal.tagName === 'QUICK-ADD-MODAL' && modal.querySelector('.hm-qa') && modal.hasAttribute('open')) {
      modal.hide();
    }
  });

  // Swipe the handle down to close (mobile sheet)
  var drag = null;
  document.addEventListener('touchstart', function (e) {
    var handle = e.target.closest ? e.target.closest('.hm-qa-handle') : null;
    if (!handle || getComputedStyle(handle).display === 'none') return;
    var content = handle.closest('.quick-add-modal__content');
    var modal = handle.closest('quick-add-modal');
    if (!content || !modal) return;
    drag = { content: content, modal: modal, startY: e.touches[0].clientY, dy: 0 };
    content.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!drag) return;
    drag.dy = Math.max(0, e.touches[0].clientY - drag.startY);
    drag.content.style.transform = 'translateY(' + drag.dy + 'px)';
  }, { passive: true });
  function endDrag() {
    if (!drag) return;
    var d = drag;
    drag = null;
    var threshold = Math.min(120, d.content.offsetHeight * 0.25);
    if (d.dy > threshold) {
      d.content.style.transition = 'transform 0.18s ease-out';
      d.content.style.transform = 'translateY(100%)';
      setTimeout(function () {
        d.modal.hide();
        d.content.style.transition = '';
        d.content.style.transform = '';
      }, 180);
    } else {
      d.content.style.transition = 'transform 0.18s ease-out';
      d.content.style.transform = '';
      setTimeout(function () { d.content.style.transition = ''; }, 200);
    }
  }
  document.addEventListener('touchend', endDrag);
  document.addEventListener('touchcancel', endDrag);
})();

